import axios from 'axios';

const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
  // withCredentials: true,
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      console.log('Status 401 received, logging out!!!!');
      localStorage.removeItem('userInfo');
      window.location.href = '/auth';
    }
    return Promise.reject(error);
  }
);

export default http;
